export default {
  C: "C",
  CSharp: "C♯",
  D: "D",
  DFlat: "D♭",
  DSharp: "D♯",
  E: "E",
  EFlat: "E♭",
  F: "F",
  FSharp: "F♯",
  G: "G",
  GFlat: "G♭",
  GSharp: "G♯",
  A: "A",
  AFlat: "A♭",
  ASharp: "A♯",
  B: "H",
  BFlat: "B",

  correctExcl: "Helyes!",
  wrongExcl: "Téves!",

  ABORT: "MÉGSE",

  lastRound: "Utolsó Kör",
  score: "Pontszám",
  accuracy: "Pontosság",
  correct: "helyes",
  wrong: "téves",

  START: "KEZDÉS",
  settings: "Beállítások",
  ROUND_LENGTH: "KÖR HOSSZÚSÁGA",
  NOTE_INPUT: "HANG BEVITELE",
  CLEF: "KULCS",
  DIFFICULTY: "NEHÉZSÉG",
  ACCIDENTALS: "MÓDOSÍTÓJELEK",
  LANGUAGE: "NYELV",
  twentySeconds: "20 mp",
  oneMinute: "1 perc",
  fiveMinutes: "5 perc",
  infinite: "Korlátlan",
  buttons: "Gombok",
  piano: "Zongora",
  trebleClef: "Violin",
  bassClef: "Basszus",
  altoClef: "Alt",
  tenorClef: "Tenor",
  easy: "Könnyű",
  normal: "Közepes",
  hard: "Nehéz",
  none: "Nincs",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ és ♭",
  SOUND: "HANG",
  VIBRATION: "VIBRÁLÁS",
  DISPLAYCORRECTNOTE: "MEGFELELŐ HANGJEGY MEGJELENÍTÉSE",
  on: "Be",
  off: "Ki",

  TIME: "IDŐ",
  CORRECT: "HELYES",
  ACCURACY: "PONTOSSÁG",
  SCORE: "PONTSZÁM",

  record: "Legmagasabb Pontszám",
  history: "Előzmények",

  noMidiSupport: "Úgy tűnik, hogy ez az eszköz nem támogatja a MIDI bevitelt.",
  noDeviceFound: "Nem található eszköz. Csatlakoztasd újra a MIDI billentyűzetet.",
  playTheNote: "Játszd a hangot a MIDI billentyűzeten.",
  lastNotePlayed: "Utolsó lejátszott hang",
};


// WEBPACK FOOTER //
// ./src/resources/hu.js